import './style.css'
import * as dat from 'lil-gui'
import * as THREE from 'three'
import { PointerLockControls } from 'three/examples/jsm/controls/PointerLockControls.js';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js'
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader.js'
import { DoubleSide } from 'three'
import { gsap } from 'gsap'

// WARNING: The code is very poorly structured, but slaying. No time for adjustments. Some day will be refined. Bye.


// Canvas
//const canvas = document.querySelector('canvas.webgl')

// Scene
let scene = new THREE.Scene()
scene.background = new THREE.Color(0xBBC1D7);

//Loading overlay
const overlayGeometry = new THREE.PlaneBufferGeometry(2, 2, 1, 1)
const overlayMaterial = new THREE.ShaderMaterial({
    transparent: true,
    uniforms:
    {
        uAlpha: { value: 1}
    },
    vertexShader: `
        void main()
        {
            gl_Position = vec4(position, 1.0);
        }
    `,
    fragmentShader: `
        uniform float uAlpha;

        void main()
        {
            gl_FragColor = vec4(102.0, 102.0, 255.0, uAlpha);
        }
    `
})

const overlay = new THREE.Mesh(overlayGeometry, overlayMaterial)
scene.add(overlay)

/**
 * Camera
 */
 let camera = new THREE.PerspectiveCamera( 75, window.innerWidth / window.innerHeight, 1, 1000 );
 camera.rotation.y =  Math.PI;
 camera.position.z = -129.5
 camera.position.x = -9

/**
 * Controls
 */

let controls = new PointerLockControls( camera, document.body );


/**
 * Loaders
 */

//Loading Manager
const loadingManager = new THREE.LoadingManager(
    // Loaded
    () =>
    {
        gsap.to(overlayMaterial.uniforms.uAlpha, { duration:3, value: 0})
        document.getElementById('loader').style.display='none'
        document.getElementById('instructions').style.display = 'flex'
    },

    // Progress
    () =>
    {
    } 
)

// Texture loader
const textureLoader = new THREE.TextureLoader(loadingManager)

// Draco loader
const dracoLoader = new DRACOLoader(loadingManager)
dracoLoader.setDecoderPath('draco/')

// GLTF loader
const gltfLoader = new GLTFLoader(loadingManager)
gltfLoader.setDRACOLoader(dracoLoader)


/**
 * Textures
 */

const bakedSkyTexture = textureLoader.load('static/baked_sky_original.jpg')
bakedSkyTexture.flipY = false
bakedSkyTexture.encoding = THREE.sRGBEncoding

const texture0 = textureLoader.load('static/baked_hotel_mechta.jpg')
texture0.flipY = false
texture0.encoding = THREE.sRGBEncoding

const texture1 = textureLoader.load('static/baked_hotel_cherno.jpg')
texture1.flipY = false
texture1.encoding = THREE.sRGBEncoding

const texture2 = textureLoader.load('static/jetkata.jpg')
texture2.flipY = false
texture2.encoding = THREE.sRGBEncoding

const texture3 = textureLoader.load('static/contest.jpg')
texture3.flipY = false
texture3.encoding = THREE.sRGBEncoding

const texture4 = textureLoader.load('static/jenichki.001.jpg')
texture4.flipY = false
texture4.encoding = THREE.sRGBEncoding

const texture5 = textureLoader.load('static/morence.jpg')
texture5.flipY = false
texture5.encoding = THREE.sRGBEncoding

const texture6 = textureLoader.load('static/list3.jpg')
texture6.flipY = false
texture6.encoding = THREE.sRGBEncoding

const texture7 = textureLoader.load('static/list2.jpg')
texture7.flipY = false
texture7.encoding = THREE.sRGBEncoding

const texture8 = textureLoader.load('static/list1.jpg')
texture8.flipY = false
texture8.encoding = THREE.sRGBEncoding

const texture9 = textureLoader.load('static/palmichki.jpg')
texture9.flipY = false
texture9.encoding = THREE.sRGBEncoding

const texture10 = textureLoader.load('static/skachach.jpg')
texture10.flipY = false
texture10.encoding = THREE.sRGBEncoding

const texture11 = textureLoader.load('static/diana.jpg')
texture11.flipY = false
texture11.encoding = THREE.sRGBEncoding

const texture12 = textureLoader.load('static/dama.jpg')
texture12.flipY = false
texture12.encoding = THREE.sRGBEncoding

const texture13 = textureLoader.load('static/chadurche.jpg')
texture13.flipY = false
texture13.encoding = THREE.sRGBEncoding

const texture14 = textureLoader.load('static/debela_dama.jpg')
texture14.flipY = false
texture14.encoding = THREE.sRGBEncoding

const texture15 = textureLoader.load('static/muskili.jpg')
texture15.flipY = false
texture15.encoding = THREE.sRGBEncoding

const texture16 = textureLoader.load('static/gola_dama.jpg')
texture16.flipY = false
texture16.encoding = THREE.sRGBEncoding

const texture17 = textureLoader.load('static/hamak.jpg')
texture17.flipY = false
texture17.encoding = THREE.sRGBEncoding

const texture18 = textureLoader.load('static/credits.png')
texture18.flipY = false
texture18.encoding = THREE.sRGBEncoding

const texture19 = textureLoader.load('static/credits_kraka.jpg')
texture19.flipY = false
texture19.encoding = THREE.sRGBEncoding

/*
* Materials
*/

const bakedSkyMaterial = new THREE.MeshBasicMaterial({ map:bakedSkyTexture, side: THREE.DoubleSide })
const textureMaterial0 = new THREE.MeshBasicMaterial({ map:texture0, side: THREE.DoubleSide })
const textureMaterial1 = new THREE.MeshBasicMaterial({ map:texture1, side: THREE.DoubleSide })
const textureMaterial2 = new THREE.MeshBasicMaterial({ map:texture2, side: THREE.DoubleSide })
const textureMaterial3 = new THREE.MeshBasicMaterial({ map:texture3, side: THREE.DoubleSide })
const textureMaterial4 = new THREE.MeshBasicMaterial({ map:texture4, side: THREE.DoubleSide })
const textureMaterial5 = new THREE.MeshBasicMaterial({ map:texture5, side: THREE.DoubleSide })
const textureMaterial6 = new THREE.MeshBasicMaterial({ map:texture6, side: THREE.DoubleSide })
const textureMaterial7 = new THREE.MeshBasicMaterial({ map:texture7, side: THREE.DoubleSide })
const textureMaterial8 = new THREE.MeshBasicMaterial({ map:texture8, side: THREE.DoubleSide })
const textureMaterial9 = new THREE.MeshBasicMaterial({ map:texture9, side: THREE.DoubleSide })
const textureMaterial10 = new THREE.MeshBasicMaterial({ map:texture10, side: THREE.DoubleSide })
const textureMaterial11 = new THREE.MeshBasicMaterial({ map:texture11, side: THREE.DoubleSide })
const textureMaterial12 = new THREE.MeshBasicMaterial({ map:texture12, side: THREE.DoubleSide })
const textureMaterial13 = new THREE.MeshBasicMaterial({ map:texture13, side: THREE.DoubleSide })
const textureMaterial14 = new THREE.MeshBasicMaterial({ map:texture14, side: THREE.DoubleSide })
const textureMaterial15 = new THREE.MeshBasicMaterial({ map:texture15, side: THREE.DoubleSide })
const textureMaterial16 = new THREE.MeshBasicMaterial({ map:texture16, side: THREE.DoubleSide })
const textureMaterial17 = new THREE.MeshBasicMaterial({ map:texture17, side: THREE.DoubleSide })
const textureMaterial18 = new THREE.MeshBasicMaterial({ map:texture18, side: THREE.DoubleSide })
const textureMaterial19 = new THREE.MeshBasicMaterial({ map:texture19, side: THREE.DoubleSide })


/*
* Model 
*/

gltfLoader.load(
    'static/paraleli_final.glb',
    (gltf) =>
    {
      const bakedSkyMesh = gltf.scene.children.find(child => child.name === 'sky')
      const textureMesh0 = gltf.scene.children.find(child => child.name === 'hotel_mechta')
      const textureMesh1 = gltf.scene.children.find(child => child.name === 'hotel_cherno')
      const textureMesh2 = gltf.scene.children.find(child => child.name === 'jetka')
      const textureMesh3 = gltf.scene.children.find(child => child.name === 'contest')
      const textureMesh4 = gltf.scene.children.find(child => child.name === 'jenichki')
      const textureMesh5 = gltf.scene.children.find(child => child.name === 'morence')
      const textureMesh6 = gltf.scene.children.find(child => child.name === 'list3')
      const textureMesh7 = gltf.scene.children.find(child => child.name === 'list2')
      const textureMesh8 = gltf.scene.children.find(child => child.name === 'list1')
      const textureMesh9 = gltf.scene.children.find(child => child.name === 'palmichki')
      const textureMesh10 = gltf.scene.children.find(child => child.name === 'skachach')
      const textureMesh11 = gltf.scene.children.find(child => child.name === 'diana')
      const textureMesh12 = gltf.scene.children.find(child => child.name === 'dama')
      const textureMesh13 = gltf.scene.children.find(child => child.name === 'chadurche')
      const textureMesh14 = gltf.scene.children.find(child => child.name === 'debela_dama')
      const textureMesh15 = gltf.scene.children.find(child => child.name === 'muskuli')
      const textureMesh16 = gltf.scene.children.find(child => child.name === 'gola_dama')
      const textureMesh17 = gltf.scene.children.find(child => child.name === 'hamak')
      const textureMesh18 = gltf.scene.children.find(child => child.name === 'credits')
      const textureMesh19 = gltf.scene.children.find(child => child.name === 'credits_kraka')

       bakedSkyMesh.material = bakedSkyMaterial
       textureMesh0.material = textureMaterial0
       textureMesh1.material = textureMaterial1
       textureMesh2.material = textureMaterial2
       textureMesh3.material = textureMaterial3
       textureMesh4.material = textureMaterial4
       textureMesh5.material = textureMaterial5
       textureMesh6.material = textureMaterial6
       textureMesh7.material = textureMaterial7
       textureMesh8.material = textureMaterial8
       textureMesh9.material = textureMaterial9
       textureMesh10.material = textureMaterial10
       textureMesh11.material = textureMaterial11
       textureMesh12.material = textureMaterial12
       textureMesh13.material = textureMaterial13
       textureMesh14.material = textureMaterial14
       textureMesh15.material = textureMaterial15       
       textureMesh16.material = textureMaterial16
       textureMesh17.material = textureMaterial17
       textureMesh18.material = textureMaterial18
       textureMesh19.material = textureMaterial19

        scene.add(gltf.scene)
        gltf.scene.position.y = 3
    }
)

var tryModel = new THREE.Object3D();

gltfLoader.load(
        'static/screen.glb',
        (gltf) =>
        {
        tryModel = gltf.scene.children.find(child => child.name === 'screen')

        const model = {}

        // Element
        model.element = document.createElement('video')
        model.element.muted = true
        model.element.loop = true
        model.element.controls = true
        model.element.playsInline = true
        model.element.autoplay = true
        model.element.src = 'static/paraleli_final.m4v'


        var playPromise = model.element.play();

        if (playPromise !== undefined) {
          playPromise.then(_ => {
            // Automatic playback started!
            // Show playing UI.
          })
          .catch(error => {
            // Auto-play was prevented
            // Show paused UI.
          });
        }

        // Texture
        model.texture = new THREE.VideoTexture(model.element)
        model.texture.encoding = THREE.sRGBEncoding
        model.texture.flipY = false;

        model.material = new THREE.MeshBasicMaterial({
            map:  model.texture,
            side: DoubleSide
            
        })

        tryModel.material = model.material
        scene.add(tryModel)
        tryModel.position.y = 14
        tryModel.scale.x = -1;

        }
    )

/**
 * Sizes
 */
const sizes = {
    width: window.innerWidth,
    height: window.innerHeight
}

/**
 * Constants
 */

let moveForward = false;
let moveBackward = false;
let moveLeft = false;
let moveRight = false;

let prevTime = performance.now();
const velocity = new THREE.Vector3();
const direction = new THREE.Vector3();

/**
 * Renderer
 */
 let renderer = new THREE.WebGLRenderer({
  //  canvas: canvas,
    antialias: true,
})
renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
//for better colors
renderer.outputEncoding = THREE.sRGBEncoding
document.body.appendChild( renderer.domElement );


window.addEventListener('resize', () =>
{
    // Update sizes
    sizes.width = window.innerWidth
    sizes.height = window.innerHeight

    // Update camera
    camera.aspect = sizes.width / sizes.height
    camera.updateProjectionMatrix()

    // Update renderer
    renderer.setSize(sizes.width, sizes.height)
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))

})

// create an AudioListener and add it to the camera
const listener = new THREE.AudioListener();
camera.add( listener );

// load a sound and set it as the Audio object's buffer
const audioLoader = new THREE.AudioLoader();

// create a global audio source
const sound = new THREE.Audio( listener );

/**
 * Events
 */

//click events

const blocker = document.getElementById( 'blocker' );
const instructions = document.getElementById( 'instructions' );


instructions.addEventListener( 'click', function () {

    if(document.getElementById('loader').style.display == 'none') {

            controls.lock();

    
        audioLoader.load( 'static/lucho_muzika.mp3', function( buffer ) {
        sound.setBuffer( buffer );
        sound.setLoop( true );
        sound.setVolume( 0.4 );
        sound.play();
    });
    }
} );

controls.addEventListener( 'lock', function () {
    instructions.style.display = 'none';
    blocker.style.display = 'none';
} );

controls.addEventListener( 'unlock', function () {

    blocker.style.display = 'block';
    instructions.style.display = 'flex';
} );

scene.add( controls.getObject() );

//move events

const onKeyDown = function ( event ) {
    if (blocker.style.display == 'none'){

    switch ( event.code ) {

        case 'ArrowUp':
        case 'KeyW':
            moveForward = true;
            break;

        case 'ArrowLeft':
        case 'KeyA':
            moveLeft = true;
            break;

        case 'ArrowDown':
        case 'KeyS':
            moveBackward = true;
            break;

        case 'ArrowRight':
        case 'KeyD':
            moveRight = true;
            break;

    }
}
};

const onKeyUp = function ( event ) {
    if (blocker.style.display == 'none'){

    switch ( event.code ) {

        case 'ArrowUp':
        case 'KeyW':
            moveForward = false;
            break;

        case 'ArrowLeft':
        case 'KeyA':
            moveLeft = false;
            break;

        case 'ArrowDown':
        case 'KeyS':
            moveBackward = false;
            break;

        case 'ArrowRight':
        case 'KeyD':
            moveRight = false;
            break;

    }
}
};

document.addEventListener( 'keydown', onKeyDown );
document.addEventListener( 'keyup', onKeyUp );

/**
 * Animate
 */

const tick = () =>
{
    
    requestAnimationFrame( tick );

    const time = performance.now();

        
    const delta = ( time - prevTime ) / 1000;

    velocity.x -= velocity.x * 10.0 * delta;
    velocity.z -= velocity.z * 10.0 * delta;

    velocity.y -= 9.8 * 100.0 * delta; // 100.0 = mass

    direction.z = Number( moveForward ) - Number( moveBackward );
    direction.x = Number( moveRight ) - Number( moveLeft );
    direction.normalize(); // this ensures consistent movements in all directions

    if ( moveForward || moveBackward ) velocity.z -= direction.z * 100.0 * delta;
    if ( moveLeft || moveRight ) velocity.x -= direction.x * 200.0 * delta;

    controls.moveRight( - velocity.x * delta );
    controls.moveForward( - velocity.z * delta );

    controls.getObject().position.y += ( velocity.y * delta ); // new behavior

    if ( controls.getObject().position.y < 10 ) {

        velocity.y = 0;
        controls.getObject().position.y = 10;


    }

    prevTime = time;

    renderer.render( scene, camera );
}

tick()